import React from 'react';
import { SwapHorizIcon } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './croppingContentHeader.module.scss';

export const CroppingContentHeader = () => (
    <>
        <div className={styles['header-label']}>
            <SwapHorizIcon />
            <FormattedMessage
                id="cropping.content.header.title"
                defaultMessage="Review your media assets for better composition"
            />
        </div>
        <div className={styles['header-sub-label']}>
            <FormattedMessage
                id="cropping.content.header.sub.title"
                defaultMessage='Optimize ad appearance by adjusting aspect ratios. Use "Replace" to upload assets in exact ratios. Keep important elements within the safe zone (41px from edges) to ensure visibility across all platforms.'
            />
        </div>
    </>
);
